(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-editorial-campaign"] && !Shopify.designMode) return;
  try {
    
  function tbRevealCampaigns(root) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.animate([{opacity:.65,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'});
          observer.unobserve(entry.target);
        }
      });
    },{threshold:.12});
    root.querySelectorAll('.tb-campaign__intro,.tb-campaign__media').forEach(el => observer.observe(el));
  }
  tbRevealCampaigns(document);
  document.addEventListener('shopify:section:load',event => tbRevealCampaigns(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-editorial-page"] && !Shopify.designMode) return;
  try {
    
  function teInitPages(){
    const hero=document.querySelector('.te-collection');
    if(!hero||hero.dataset.motionBound)return;
    hero.dataset.motionBound='true';
    const media=matchMedia('(prefers-reduced-motion:reduce)');
    let pending=false;
    const update=()=>{pending=false;const rect=hero.getBoundingClientRect();if(rect.bottom>=0&&rect.top<=innerHeight)hero.style.setProperty('--te-shift',media.matches?'0px':`${Math.max(0,-rect.top)*.12}px`);};
    addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true,capture:true});
    media.addEventListener('change',update);update();
  }
  teInitPages();document.addEventListener('shopify:section:load',teInitPages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-motion-hero"] && !Shopify.designMode) return;
  try {
    
  function tmInitMotion() {
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = media.matches;
    let pending = false;
    const buttons = [...document.querySelectorAll('[data-motion-toggle]')];
    buttons.forEach(button => {
      button.hidden = false;
      button.addEventListener('click',() => { paused = !paused; updateState(); });
    });
    function updateState() {
      document.documentElement.classList.toggle('tm-motion-paused',paused);
      buttons.forEach(button => { button.setAttribute('aria-pressed',String(paused)); button.textContent = paused ? button.dataset.resume || 'Resume motion' : button.dataset.pause || 'Pause motion'; });
      update();
    }
    function update() {
      pending = false;
      document.querySelectorAll('[data-motion-hero]').forEach(hero => {
        const rect=hero.getBoundingClientRect();
        if(rect.bottom < -100 || rect.top > innerHeight+100)return;
        const progress=Math.max(0,Math.min(1,-rect.top/rect.height));
        hero.style.setProperty('--hero-y',paused?'0px':`${progress*90}px`);
        hero.style.setProperty('--hero-r',paused?'0deg':`${progress*-3}deg`);
      });
      document.querySelectorAll('[data-runway]').forEach(runway => {
        const rect=runway.getBoundingClientRect();
        if(rect.bottom < -100 || rect.top > innerHeight+100)return;
        const progress=Math.max(0,Math.min(1,-rect.top/Math.max(1,rect.height-innerHeight)));
        runway.style.setProperty('--runway-x',paused?'0px':`${(progress-.5)*120}px`);
        runway.style.setProperty('--runway-y',paused?'0px':`${(progress-.5)*-65}px`);
        runway.style.setProperty('--runway-r',paused?'0deg':`${(progress-.5)*6}deg`);
        runway.style.setProperty('--runway-word',paused?'0px':`${(progress-.5)*-100}px`);
      });
    }
    addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true,capture:true});
    addEventListener('resize',update,{passive:true});
    media.addEventListener('change',()=>{paused=media.matches;updateState();});
    updateState();
  }
  tmInitMotion();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-motion-products"] && !Shopify.designMode) return;
  try {
    
  function tmInitConveyors(){ document.querySelectorAll('.tm-moving').forEach(section=>{
    if(section.classList.contains('tm-ready'))return;
    const track=section.querySelector('.tm-moving__track');
    const source=section.querySelector('.tm-moving__set');
    if(!source.children.length)return;
    const copy=source.cloneNode(true);
    copy.setAttribute('aria-hidden','true');
    copy.querySelectorAll('a').forEach(a=>a.setAttribute('tabindex','-1'));
    track.append(copy);
    section.classList.add('tm-ready');
    const button=section.querySelector('[data-carousel-toggle]');
    button.hidden=false;
    button.addEventListener('click',()=>{
      const paused=section.classList.toggle('tm-user-paused');
      button.setAttribute('aria-pressed',String(paused));
      button.textContent=paused?button.dataset.resume:button.dataset.pause;
    });
  }); }
  tmInitConveyors();
  document.addEventListener('tm:catalog-ready',tmInitConveyors);
  document.addEventListener('shopify:section:load',tmInitConveyors);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-motion-shop"] && !Shopify.designMode) return;
  try {
    
  function tmInitShop(){document.querySelectorAll('.tm-shop').forEach(section=>{
    if(section.dataset.bound==='true')return;
    if(!section.querySelector('.tm-card'))return;
    section.dataset.bound='true';
    const filters=section.querySelector('.tm-shop__filters');
    filters.hidden=false;
    filters.querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>{
      filters.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      section.querySelectorAll('.tm-card').forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.category!==button.dataset.filter;});
    }));
    section.querySelectorAll('.tm-card__flip').forEach(button=>{
      button.hidden=false;
      button.addEventListener('click',()=>{
        const flipped=button.closest('.tm-card').classList.toggle('tm-flipped');
        button.setAttribute('aria-pressed',String(flipped));
        button.textContent=flipped?button.dataset.front:button.dataset.back;
      });
    });
    section.querySelectorAll('[data-open]').forEach(button=>{
      const dialog=document.getElementById(button.dataset.open);
      if(!dialog||!dialog.showModal)return;
      button.hidden=false;
      button.addEventListener('click',()=>dialog.showModal());
      dialog.querySelector('.tm-dialog__close').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>button.focus());
      dialog.querySelector('select').addEventListener('change',event=>{const choice=event.target.selectedOptions[0];if(choice?.dataset.price)dialog.querySelector('[data-price]').textContent=choice.dataset.price;});
    });
  });}
  tmInitShop();
  document.addEventListener('tm:catalog-ready',tmInitShop);
  document.addEventListener('shopify:section:load',tmInitShop);
  async function tmHydrateCatalog(section) {
    if(section.querySelector('.tm-card')||section.dataset.loading)return;
    section.dataset.loading='true';
    const status=section.querySelector('.tm-shop__status');
    const root=section.dataset.root||'/';
    const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:section.dataset.currency||'USD'}).format(value/100);
    const imageUrl=(src,width)=>{const u=new URL(src,location.origin);u.searchParams.set('width',String(width));return u.href;};
    try {
      const response=await fetch(section.dataset.catalogUrl,{credentials:'same-origin'});
      if(!response.ok)throw new Error('catalog');
      const catalog=await response.json();
      const products=await Promise.all((catalog.products||[]).slice(0,12).map(async entry=>{
        const response=await fetch(`${root}products/${encodeURIComponent(entry.handle)}.js`,{credentials:'same-origin'});
        if(!response.ok)return null;
        return response.json();
      }));
      const available=products.filter(Boolean);
      if(!available.length)throw new Error('empty');
      const template=section.querySelector('[data-tm-card]');
      const grid=section.querySelector('.tm-shop__grid');
      for(const product of available){
        const card=template.content.firstElementChild.cloneNode(true);
        card.dataset.category=/jeans|shorts|pants/.test(product.handle)?'bottoms':'tops';
        const href=`${root}products/${encodeURIComponent(product.handle)}`;
        card.querySelectorAll('a').forEach(a=>a.href=href);
        card.querySelector('[data-card-title]').textContent=product.title;
        const price=money(product.price);
        card.querySelector('[data-card-price]').textContent=price;
        card.querySelector('[data-price]').textContent=price;
        const dialog=card.querySelector('dialog');
        const id=`tm-quick-${section.id}-${product.id}`;
        dialog.id=id;
        dialog.setAttribute('aria-labelledby',`${id}-title`);
        const heading=card.querySelector('[data-dialog-title]');heading.id=`${id}-title`;heading.textContent=product.title;
        card.querySelector('.tm-card__quick').dataset.open=id;
        card.querySelector('.tm-card__image').setAttribute('aria-label',product.title);
        const images=product.images||[];
        card.querySelectorAll('.tm-card__front,.tm-dialog__image img').forEach(img=>{img.src=imageUrl(images[0],900);img.alt=product.title;img.srcset=`${imageUrl(images[0],350)} 350w, ${imageUrl(images[0],600)} 600w, ${imageUrl(images[0],900)} 900w`;img.sizes='(max-width:749px) 46vw, 30vw';});
        if(images[1]){const back=card.querySelector('.tm-card__back');back.src=imageUrl(images[1],900);back.alt=product.title;}
        else {card.querySelector('.tm-card__back').remove();card.querySelector('.tm-card__flip').remove();}
        const select=card.querySelector('select');select.id=`${id}-variant`;card.querySelector('label').htmlFor=select.id;
        for(const variant of product.variants){const option=document.createElement('option');option.value=variant.id;option.textContent=variant.title;option.disabled=!variant.available;option.dataset.price=money(variant.price);select.append(option);}
        card.querySelector('[type=submit]').disabled=!product.available;
        grid.append(card);
      }
      document.querySelectorAll('.tm-moving').forEach(moving=>{
        const set=moving.querySelector('.tm-moving__set');
        if(set.children.length)return;
        for(const product of available.slice(0,6)){
          const link=document.createElement('a');link.className='tm-moving__piece';link.href=`${root}products/${encodeURIComponent(product.handle)}`;
          const wrap=document.createElement('div'),img=document.createElement('img'),title=document.createElement('span'),price=document.createElement('span');
          img.src=imageUrl(product.images[0],700);img.alt=product.title;img.loading='lazy';img.width=1086;img.height=1448;wrap.append(img);title.textContent=product.title;price.textContent=`${money(product.price)}`;link.append(wrap,title,price);set.append(link);
        }
      });
      document.querySelectorAll('[data-feature-handle]').forEach(feature=>{
        const product=available.find(p=>p.handle===feature.dataset.featureHandle);if(!product)return;
        const href=`${root}products/${encodeURIComponent(product.handle)}`;
        if(feature.matches('.tm-hero')&&!feature.querySelector('.tm-hero__product')){
          const link=document.createElement('a');link.className='tm-hero__product';link.href=href;
          const title=document.createElement('span'),price=document.createElement('span');title.textContent=product.title;price.textContent=`${money(product.price)}`;link.append(title,price);feature.querySelector('.tm-hero__stage').append(link);
        }
        if(feature.matches('.tm-runway')&&!feature.querySelector('.tm-button')){
          const link=document.createElement('a');link.className='tm-button';link.href=href;link.textContent=feature.querySelector('.tm-runway__copy').dataset.linkLabel;feature.querySelector('.tm-runway__copy').append(link);
        }
      });
      status.textContent='';
      document.dispatchEvent(new CustomEvent('tm:catalog-ready'));
    } catch(error){status.textContent=section.dataset.loadError;}
  }
  document.querySelectorAll('.tm-shop').forEach(tmHydrateCatalog);


  } catch(e) { console.error(e); }
})();
})();
